import {
  Divider,
  Fab,
  Grid,
  makeStyles,
  Typography,
} from "@material-ui/core";
import ListItem from "@material-ui/core/ListItem";
import CheckIcon from "@material-ui/icons/Check";
// import { withStyles } from "@material-ui/core/styles";
import { empresaPreAfiliadoInsertStart } from "../../actions/empresasPreafiliado";
import { useDispatch, useSelector } from "react-redux";
import {ValidarAltaAporte} from "../../helpers/validarAltaAporte"
import moment from "moment";
import { AREAS_USUARIOS } from "../../utils/constants";

/* const TextTypography = withStyles({
  root: {
    color: "#0000ff",
  },
})(Typography); */
const useStyles = makeStyles({
  root: {
    maxWidth: 345,
  },
  media: {
    height: 140,
  },
  container: {
    margin: 7,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  button: {
    marginLeft: 10,
  },
});
export const ItemAportesEmpresas = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const labelId = `checkbox-list-secondary-label-${props.item.empresa?.cuit}`;
  const { areas } = useSelector((state) => state.auth);

  const addEmpresa=(item)=>{
    const empresa={ 
      idEmpresa:item.empresa.idEmpresa,
      idEmpresaAfiliado:null,
      fechaDesde:moment().format(),
      fechaHasta:null,
      empresa:{
        denominacion:"",
         domicilio:"",
         codigoPostal:0,
         telefono:"",
         email:"",
         idSeccional:null,
         idProvincia:null,
         idLocalidad:null,
         cuit:item.empresa.cuit,
         idEmpresa:item.empresa.idEmpresa,
         fechaAlta:null,
         fechaBaja:null,
         observacion:"",
         idMotivoBaja:null
      }
      
    }
    dispatch(empresaPreAfiliadoInsertStart(empresa));
  };

  const esNacional = areas.filter((e) => e.idArea === AREAS_USUARIOS.NACIONAL);


  return (
    <div>
      <ListItem
        key={props.item.empresa?.cuit}
        button
        className={classes.container}
      >
        <Grid id={labelId}>
          <Typography variant="h6" style={{ backgroundColor: props.item?.empresa?.esdelarama === false && esNacional ? '#FF7F3E' : 'inherit'}}>
            <strong>Denominación:</strong>
            {` ${
              props.item.empresa
                ? props.item.empresa.denominacion
                : "NO EMPADRONADA"
            } CUIT:${props.item.empresa?.cuit}`}
          </Typography>
        </Grid>
        <Grid id={labelId}>
          <Typography variant="h6">
            <strong>Ultimo Periodo declarado:</strong>
            {` ${props.item.periodo
              .toString()
              .substr(4, 2)} / ${props.item.periodo.toString().substr(0, 4)} `}
          </Typography>
        </Grid>
        <Grid className>
          {props.item.empresa.denominacion ? (
            <Fab
              id={labelId}
              className={classes.button}
              variant="extended"
              color="secondary"
              aria-label="add"
              size="small"
              disabled={props.item.empresa!==null&&ValidarAltaAporte(props.item.empresa?.cuit)}
              onClick={() => addEmpresa(props.item)}
            >
              <CheckIcon />
            </Fab>
          ) : null}
        </Grid>
      </ListItem>
      <Divider />
    </div>
  );
};
